import React, { FC } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import MainLayout from 'components/main-layout/MainLayout';
import API from 'core/Api';
import { buildClientEntity } from 'utils/helpers/client';
import { useActiveClientContext } from 'store/active-client';
import { useTranslation } from 'react-i18next';
import StepFour from './components/StepFour';

const Screen: FC = () => {
  const { t } = useTranslation();
  const { client } = useActiveClientContext();

  const params = useParams<{ id: string | undefined }>();

  const { isLoading, error, data } = useQuery(buildClientEntity('step-four', client), () =>
    API.get<[]>(`document-wizard/step-four/${params.id || ''}`).then(res => res.data)
  );

  return (
    <MainLayout
      title={t(params.id ? 'docWizard.editTitle' : 'docWizard.title')}
      isLoading={isLoading}
      error={error}
    >
      {data && <StepFour data={data} />}
    </MainLayout>
  );
};

export default Screen;
